import { api } from "../../utils";
import {
  GET_STORES_COMPLAINS,
  GET_TOTAL_COMPLAINS,
  GET_WEEKLY_COMPLAINS,
} from "../ApiConstants";

class DashBoardApi {
  static sharedInstance = new DashBoardApi();

  constructor() {
    if (DashBoardApi.sharedInstance != null) {
      return DashBoardApi.sharedInstance;
    }
  }

  //   Get total complains count ..
  async getTotalComplains() {
    try {
      const response = await api.get(`${GET_TOTAL_COMPLAINS}`);
      const { success, data } = response.data;
      if (success) {
        return data;
      }
    } catch (error) {
      return error.response.data;
    }
  }
  //   Get stores complains count  ..
  async getStoresComplains() {
    try {
      const response = await api.get(`${GET_STORES_COMPLAINS}`);
      const { success, data } = response.data;
      if (success) {
        return data;
      }
    } catch (error) {
      return error.response.data;
    }
  }

  // Get weekly complains  ..

  async getWeeklyComplains() {
    try {
      const response = await api.get(`${GET_WEEKLY_COMPLAINS}`);
      const { success, data } = response.data;
      if (success) {
        return data;
      }
    } catch (error) {
      return error.response.data;
    }
  }
}

export default DashBoardApi.sharedInstance;
